var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ad-box",style:(_vm.gridStyle)},_vm._l((_vm.banners),function(ref){
var imageUrl = ref.imageUrl;
var size = ref.size;
var side = ref.side;
var position = ref.position;
return _c('div',{staticClass:"adimg contain bg-center",style:({ gridArea: _vm.getGridArea({ size: size, side: side, position: position}), backgroundImage: ("url(" + imageUrl + ")") })})}))}
var staticRenderFns = []

export { render, staticRenderFns }